import { ChevronRightIcon } from '@c/icons';
import Link from 'next/link';

export type BreadcrumbItem = {
  label: string;
  href: string;
  current?: boolean;
  currentCss?: string;
};

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  color?: string;
  onProductDetails?: boolean;
  wrap?: boolean;
}

const Breadcrumb = ({
  items,
  color = 'text-brand-secondary',
  onProductDetails = false,
  wrap = false,
}: BreadcrumbProps) => {
  return (
    <div
      className={
        'overflow-x-none flex items-center whitespace-nowrap font-medium sm:flex-wrap sm:gap-[0.7rem]' +
        (onProductDetails ? ' pb-4' : ' p-4') +
        (wrap ? ' flex-wrap' : '')
      }
    >
      {items.map((item, i) => (
        <div
          key={`breadcrumb-${i}`}
          className="flex items-center sm:gap-[0.7rem] "
        >
          {item.current ? (
            <p className={item.currentCss}>{item.label}</p> //don't use link for current
          ) : (
            <Link className={color} href={item.href}>
              {item.label}
            </Link>
          )}
          {i !== items.length - 1 && <ChevronRightIcon className="h-8 w-8" />}
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb;
